import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Uncaught error:", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 text-center bg-background text-foreground">
          <div className="max-w-sm">
            <AlertTriangle className="mx-auto text-destructive mb-4" size={48} />
            <h1 className="font-heading font-bold text-2xl mb-2">Something went wrong</h1>
            <p className="text-muted-foreground mb-6">
              An unexpected error occurred. Please try again — if the problem continues, contact support.
            </p>
            <Button onClick={() => { this.setState({ hasError: false }); window.location.href = "/"; }} className="rounded-xl h-11 px-6">
              Go to Home
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
